import { render, staticRenderFns } from "./WarehouseProduct.vue?vue&type=template&id=67994459&scoped=true&"
import script from "./WarehouseProduct.vue?vue&type=script&lang=js&"
export * from "./WarehouseProduct.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseProduct.vue?vue&type=style&index=0&id=67994459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67994459",
  null
  
)

export default component.exports